import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'selectAll'];

  toggleAll(event) {
    this.checkboxTargets.forEach(
      (checkbox) => (checkbox.checked = event.target.checked),
    );
    this.selectAllTarget.indeterminate = false;
  }

  toggleCheckbox() {
    const checkedCount = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked,
    ).length;

    this.selectAllTarget.checked = checkedCount === this.checkboxTargets.length;
    this.selectAllTarget.indeterminate =
      checkedCount > 0 && checkedCount < this.checkboxTargets.length;
  }
}
